import { AuthBindings } from "@refinedev/core";
import axiosInstance from "../lib/axios";
import { API_ENDPOINTS } from "../config/api";
import { MONITORING_AUTH_CONFIG } from "../config/auth";

export const monitoringAuthProvider: AuthBindings = {
  login: async ({ username, password }) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.monitoring.auth.login, {
        username,
        password,
      });

      if (response.data.success && response.data.data?.accessToken) {
        localStorage.setItem(MONITORING_AUTH_CONFIG.tokenKey, response.data.data.accessToken);
        return {
          success: true,
          redirectTo: MONITORING_AUTH_CONFIG.protectedPath,
        };
      }

      return {
        success: false,
        error: {
          name: "LoginError",
          message: "이메일 또는 비밀번호가 올바르지 않습니다.",
        },
      };
    } catch (error: any) {
      return {
        success: false,
        error: {
          name: "LoginError",
          message: error?.response?.data?.message || "로그인에 실패했습니다.",
        },
      };
    }
  },

  logout: async () => {
    localStorage.removeItem(MONITORING_AUTH_CONFIG.tokenKey);
    return {
      success: true,
      redirectTo: MONITORING_AUTH_CONFIG.loginPath,
    };
  },

  check: async () => {
    const token = localStorage.getItem(MONITORING_AUTH_CONFIG.tokenKey);
    if (token) {
      return { authenticated: true };
    }

    return {
      authenticated: false,
      redirectTo: MONITORING_AUTH_CONFIG.loginPath,
    };
  },

  getPermissions: async () => {
    const token = localStorage.getItem(MONITORING_AUTH_CONFIG.tokenKey);
    return token ? ["admin"] : null;
  },

  getIdentity: async () => {
    const token = localStorage.getItem(MONITORING_AUTH_CONFIG.tokenKey);
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        id: payload.sub,
        name: payload.name || payload.email,
        email: payload.email,
      };
    } catch {
      return null;
    }
  },

  onError: async (error) => {
    if (error?.response?.status === 401) {
      return {
        logout: true,
        redirectTo: MONITORING_AUTH_CONFIG.loginPath,
        error,
      };
    }
    return { error };
  },
};
